// Day.js configuration
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import "dayjs/locale/tr"; // Import Turkish locale

dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);

window.dayjs = dayjs;

// Apexcharts
import ApexCharts from "apexcharts";
window.ApexCharts = ApexCharts;

// Alpine
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import mask from "@alpinejs/mask";
import morph from "@alpinejs/morph";
import persist from "@alpinejs/persist";
import sort from "@alpinejs/sort";
import ui from "@alpinejs/ui";
import Alpine from "alpinejs";

import options_editor from "./components/application_form_fields/options_editor.js";
import command_palette from "./components/command_palette/command_palette.js";
import email_editor from "./components/email_editor/email_editor.js";
import filter from "./components/filter/filter.js";
import combobox from "./components/form_inputs/combobox.js";
import file_input from "./components/form_inputs/file_input.js";
import phone_input from "./components/form_inputs/phone_input.js";
import job_form from "./components/job_posting_wizard/job_form.js";
import workflow from "./components/job_posting_wizard/workflow.js";
import organization_sortable from "./components/organizations/organization_sortable.js";
import text_editor from "./components/text_editor/text_editor.js";
import wysiwyg from "./components/wysiwyg/wysiwyg.js";
import availability_calendar from "./pages/scheduling/components/availability_calendar.js";

Alpine.plugin(focus);
Alpine.plugin(ui);
Alpine.plugin(morph);
Alpine.plugin(mask);
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(sort);
Alpine.plugin(intersect);

// Global stores
Alpine.store("filterFields", {
  fields: [],

  add(field) {
    this.fields.push(field);
  },
  remove(field) {
    const index = this.fields.indexOf(field);
    this.fields.splice(index, 1);
  },
  has(field) {
    return this.fields.includes(field) ? true : false;
  },
  flush() {
    this.fields = [];
  },
});

Alpine.store("filterFieldsAndTheirItems", {
  fields: {},

  getTheFieldsItself() {
    return JSON.stringify(this.fields);
  },
  add(key, value) {
    this.fields[key] = value;
  },
  remove(key) {
    delete this.fields[key];
  },
  removeFromCustomFields(customFieldMainKey, key) {
    const customFields = JSON.parse(this.get(customFieldMainKey));
    // now we got the main one, it will be like [{field_id: '32121321'}]
    // I will go ahead, iterate over it, find the one with it and kill it
    const filteredCustomFields = customFields.filter((i) => i.field_id != key);

    // then update the custom fields with it again
    this.add(customFieldMainKey, JSON.stringify(filteredCustomFields));
  },
  has(key) {
    return typeof this.fields[key] !== "undefined";
  },
  get(key) {
    const val = this.fields[key];
    if (typeof key === "undefined") {
      return null;
    } else {
      return val;
    }
  },
  flush() {
    this.fields = {};
  },
});

window.Alpine = Alpine;

window.Alpine.data("email_editor", email_editor);
window.Alpine.data("text_editor", text_editor);
window.Alpine.data("wysiwyg", wysiwyg);
window.Alpine.data("combobox", combobox);
window.Alpine.data("file_input", file_input);
window.Alpine.data("workflow", workflow);
window.Alpine.data("organization_sortable", organization_sortable);
window.Alpine.data("job_form", job_form);
window.Alpine.data("options_editor", options_editor);
window.Alpine.data("phone_input", phone_input);
window.Alpine.data("filter", filter);
window.Alpine.data("command_palette", command_palette);
window.Alpine.data("availability_calendar", availability_calendar);

window.Alpine.start();

// Flowbite
import "flowbite";
